export const bank = {
    connectModes:{
        MODAL: 1,
        NEW_WINDOW: 2
    }
}